<template>
  <div
  class="favorite-vacancy-card"
  @click="emit('open', vacancy.vacancy_id)"
>
    <div class="left">
      <img :src="vacancy.company_logo_url || '/default_company_logo.png'" alt="Company Logo" class="logo" />
    </div>
    <div class="middle">
      <h3 class="title">{{ vacancy.title }}</h3>
      <p class="company">{{ vacancy.company_name }}</p>
      <p class="info">{{ vacancy.info }}</p>
    </div>
    <div class="right">
      <img
        src="/like_active.png"
        alt="Удалить из избранного"
        class="heart-icon"
        @click.stop="emit('remove', vacancy.vacancy_id)"
      />
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['remove', 'open'])

defineProps({
  vacancy: {
    type: Object,
    required: true
  }
})
</script>

<style scoped>

.favorite-vacancy-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f5f5f5;
  border-radius: 16px;
  padding: 16px 20px;
  gap: 16px;
  box-shadow: 0 4px 12px rgba(43, 13, 13, 0.04);
  transition: box-shadow 0.2s ease-in-out;
  width: 400px;
  height: 140px;
}

.favorite-vacancy-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.left .logo {
  width: 48px;
  height: 48px;
  border-radius: 24px;
  object-fit: cover;
  flex-shrink: 0;
  margin-top: -40px;
}

.middle {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: hidden;
}

.title {
  font-family: "Eastman-Bold", sans-serif;
  font-size: 14px;
  color: var(--text-color);
  margin: 0;
  line-height: 1.1;
}

.company {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
  margin-bottom: -12px;
}

.info {
  font-size: 11px;
  color: rgba(120, 120, 120, 0.9); /* светлее и мягче */
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;   /* 👈 теперь 3 строки */
  -webkit-box-orient: vertical;
  line-height: 1.2;        
}

.right {
  display: flex;
  align-items: flex-start;
  margin-top: -40px; 
}

.heart-icon {
  margin-top: -30px;
  width: 20px;
  height: 16px;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.heart-icon:hover {
  transform: scale(1.15);
  opacity: 0.8;
}

[data-theme="dark"] .favorite-vacancy-card {
  background-color: #2a2a2a;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.05);
}

[data-theme="dark"] .title {
  color: #fff;
}

[data-theme="dark"] .company,
[data-theme="dark"] .info {
  color: #cfcfcf;
}

[data-theme="dark"] .heart-icon:hover {
  opacity: 0.9;
}

.favorite-vacancy-card {
  cursor: pointer;
  transition: all 0.25s ease;
}

.favorite-vacancy-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.12);
}

[data-theme="dark"] .favorite-vacancy-card:hover {
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.4);
}

@media (max-width: 430px) {
  .favorite-vacancy-card {
    width: 100%;
    min-height: 132px;
    height: auto;

    padding: 14px;
    gap: 12px;

    align-items: flex-start;
    border-radius: 18px;
  }

  .left .logo {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    margin-top: 0;
  }

  .middle {
    min-width: 0;
    gap: 5px;
  }

  .title {
    font-size: 14px;
    line-height: 1.2;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .company {
    font-size: 12px;
    margin-bottom: 0;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .info {
    font-size: 11px;
    line-height: 1.35;
    margin: 4px 0 0;

    -webkit-line-clamp: 3;
  }

  .right {
    margin-top: 0;
    flex-shrink: 0;
  }

  .heart-icon {
    margin-top: 2px;
    width: 22px;
    height: 18px;
  }

  .favorite-vacancy-card:hover {
    transform: none;
  }
}

</style>